import { createRoute } from '@tanstack/react-router';
import { lazy } from 'react';
import { authenticatedRoute } from '../_authenticated';

const SubmissionDetailPage = lazy(() =>
  import('@/features/forms/components/SubmissionDetailPage').then((m) => ({
    default: m.SubmissionDetailPage,
  })),
);

export const submissionDetailRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/forms/submissions/$submissionId',
  component: SubmissionDetailPage,
});
